import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ArrowDownIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M8.5,14.91 L15.7,7.71 L14.3,6.29 L9.5,11.09 L9.5,1 L7.5,1 L7.5,11.09 L2.7,6.29 C1.76,7.21 1.3,7.69 1.3,7.71 C1.3,7.73 3.7,10.13 8.5,14.91 Z"
        data-testid="icon-arrowDown"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
